import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { BaseService } from '../base/base.service';
import { SessionUserHashManagerService } from '../session-user-hash-manager/session-user-hash-manager.service';

@Injectable({
  providedIn: 'root'
})
export class ExternalSitesService extends BaseService {

  private endpoint: string = environment.apiUrl;

  constructor(
    private httpClient: HttpClient,
    protected hashManagerService: SessionUserHashManagerService
    ) {
    super(hashManagerService);
    this.endpoint += this.endpoint.endsWith("/") ? "" : "/";
  }

  public secureLinkRetrieval(token: string) {
    return this.httpClient.post(this.endpoint + 'api/ExternalSite/SecureLinkRetrieval',
      { "LinkAccessKey": token },
      this.prepareOptions({ "LinkAccessKey": token })).pipe(
        map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('secureLinkRetrieval'))
      );
  }

}